module.exports = __webpack_public_path__ + "img/mingyong57.7dce5ecc.png";